import { motion } from "framer-motion";
import { FC } from "react";

const MainHeadline: FC = () => (
  <motion.h1
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.4 }}
    className="font-bold text-gray-900 desktop:text-[4.5rem] laptop:text-[4rem] tablet:text-5xl mobile:text-4xl desktop:leading-[1.05] laptop:leading-[1.05] tablet:leading-tight mobile:leading-tight mb-8"
  >
    AI Agent Infrastructure
    <br />
    <span className="text-gray-400">for Capital Markets</span>
  </motion.h1>
);

export default MainHeadline;
